import React from "react";
import PropTypes from "prop-types";
import { Form, Button } from "semantic-ui-react";
import CustomSearch from "../shared/CustomSearch";
import _ from "lodash";

class AlumnosDisponibles extends React.Component {
  state = {
    value: ""
  };

  handleButtonClick = () => {
    this.props.handleButtonClick(this.state.value);
    this.setState({ value: "reset" });
  };

  handleSelection = value => this.setState({ value });

  render() {
    const { value } = this.state;
    return (
      <Form.Group>
        <CustomSearch
          id="buscadorAlumnos"
          name="buscadorAlumnos"
          type="text"
          datosBusqueda={this.props.datosBusqueda}
          onSelect={this.handleSelection}
          icon="search"
          value={value === "reset" ? value : ""}
        />
        <Button
          disabled={_.isEmpty(this.state.value)}
          basic
          type="button"
          color="pink"
          onClick={this.handleButtonClick}
        >
          Añadir Alumno
        </Button>
      </Form.Group>
    );
  }
}

AlumnosDisponibles.propTypes = {
  handleButtonClick: PropTypes.func,
  datosBusqueda: PropTypes.array.isRequired
};

export default AlumnosDisponibles;



// WEBPACK FOOTER //
// ./src/pages/asignacionAlumnos/AlumnosDisponibles.jsx